// extracted by mini-css-extract-plugin
export default {"header":"P21UKBVJ7pb86VOd3EFL","title":"EdhnGQXasQdjNqaDMEeR"};